import React from "react";

const OrganismNameContext = React.createContext(null);

export { OrganismNameContext };